<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">Инструкция по установке трекинг-кода Buzzoola для формирования сегментов ретаргетинга (desktop only)</div>

    <div class="markup__h markup__h_3">
      <strong>1. Получение ID магазина</strong>
    </div>
    <p>Необходимо получить ID магазина у вашего менеджера Buzzoola (или в клиентской службе <strong>ask@buzzoola.com</strong>). Далее этот ID будет использоваться в коде трекинга.</p>
    <br>
    <div class="markup__h markup__h_3">
      <strong>2. Подключение библиотеки</strong>
    </div>
    <p>
      В <code class="markup__code">&lt;head></code> страницы или любое удобное место необходимо подключить скрипт трекинга <code class="markup__code">https://tube.buzzoola.com/build/buzzretarget.js</code>
    </p>
    <br>
    <div class="markup__h markup__h_4 markup__h_orange">
      <strong>Пример подключения в <code class="markup__code">&lt;head></code></strong>
    </div>

    <pre>
      <code class="language-html">
    &lt;head>
        &lt;meta charset="UTF-8">
        &lt;meta name="viewport" content="width=device-width, initial-scale=1">
        &lt;title>Dish shop&lt;/title>
        &lt;script defer src="https://tube.buzzoola.com/build/buzzretarget.js">&lt;/script>
    &lt;/head>
      </code>
    </pre>

    <div class="markup__h markup__h_3">
      <strong>3. Установка кода на страницы</strong>
    </div>
    <p>Необходимо установить код на следующие типы событий на сайте:</p>
    <table>
      <thead>
        <tr>
          <th>Событие</th>
          <th>Значение <strong>eventid</strong></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Товар просмотрен</td>
          <td>view</td>
        </tr>
        <tr>
          <td>Товар добавлен в корзину</td>
          <td>cart.add</td>
        </tr>
        <tr>
          <td>Товар удален из корзины</td>
          <td>cart.remove</td>
        </tr>
        <tr>
          <td>Товар куплен</td>
          <td>purchase</td>
        </tr>
        <tr>
          <td>Опция: Товар добавлен в список Избранное</td>
          <td>wishlist.add</td>
        </tr>
        <tr>
          <td>Опция: Товар удален из списка Избранное</td>
          <td>wishlist.remove</td>
        </tr>
      </tbody>
    </table>
    <div class="html2pdf__page-break"/>
    <br>
    <div class="markup__h markup__h_3">
      <strong>Каждое событие содержит три поля:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li><strong>shopid</strong> <i>(строка)</i> - идентификатор магазина / продавца (получите его у менеджера Buzzoola)</li>
      <li><strong>productid</strong> <i>(строка)</i> - идентификатор товара. Сюда подставляете идентификатор товара, по которому будет отправлено событие.</li>
      <li><strong>eventid</strong> <i>(строка)</i> - название события</li>
    </ul>
    <p>Для отправки событий их необходимо добавить в глобальный список buzzoolaRetarget. Как только скрипт будет загружен и готов к работе, он автоматически начнет отправлять события из списка.</p>

    <br><br>
    <div class="markup__h markup__h_4 markup__h_orange">
      <strong>Пример отправки события о том, что товар с идентификатором "22222" был просмотрен пользователем:</strong>
    </div>
    <pre>
      <code class="language-html">
    &lt;script>
        (window.buzzoolaRetarget = window.buzzoolaRetarget || []).push({
            shopid: '11111',
            productid: '22222',
            eventid: 'view'
        });
    &lt;/script>
      </code>
    </pre>

    <div class="markup__h markup__h_4 markup__h_orange">
      <strong>Пример отправки (добавления в список) нескольких событий: товар с идентификатором "22222" был удален из списка желаемого (избранное), а товар с идентификатором "33333" добавлен в этот список:</strong>
    </div>
    <pre>
      <code class="language-html">
    &lt;script>
        (window.buzzoolaRetarget = window.buzzoolaRetarget || []).push({
            shopid: '11111',
            productid: '22222',
            eventid: 'wishlist.remove'
        }, {
            shopid: '11111',
            productid: '33333',
            eventid: 'wishlist.add'
        });
    &lt;/script>
      </code>
    </pre>

    <div class="html2pdf__page-break"/>
    <div class="markup__h markup__h_4 markup__h_orange">
      <strong>Пример отложенной отправки (добавления в список) события: событие отправится через 3 секунды (3000 миллисекунд):</strong>
    </div>
    <pre>
      <code class="language-html">
    &lt;script>
        setTimeout(function() {
            (window.buzzoolaRetarget = window.buzzoolaRetarget || []).push({
                shopid: '11111',
                productid: '22222',
                eventid: 'view'
            });
        }, 3000);
    &lt;/script>
      </code>
    </pre>

    <div class="markup__h markup__h_4 markup__h_orange">
      <strong>Пример отмены отложенной отправки (добавления в список) события: отправка события будет отменена (если еще не была осуществлена) при выполнении условия condition:</strong>
    </div>
    <pre>
      <code class="language-html">
    &lt;script>
        var eventTimeout = setTimeout(function() {
            (window.buzzoolaRetarget = window.buzzoolaRetarget || []).push({
                shopid: '11111',
                productid: '22222',
                eventid: 'view'
            });
        }, 3000);

        // Клиентский код

        if (condition) {
            clearTimeout(eventTimeout);
        }
    &lt;/script>
      </code>
    </pre>

  </div>
</template>

<script>
import hljs from '@/plugins/highlight.min';

export default {
  name: 'dynamicRetarget',
  components: {},
  data() {
    return {};
  },
  mounted() {
    hljs.highlightAll();
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/darcula.min.css'
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
